import classNames from 'classnames'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

export default class OverlayTile extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    count: PropTypes.number,
    style: PropTypes.object
  }

  render() {
    const { children, className, count, style } = this.props
    const classes = classNames('overlay-tile', className)

    return (
      <div className={classes} style={style}>
        {count != null && <div className="object-count right">{count}</div>}
        {children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/OverlayTile.js